import { useMemo } from 'react';

import { useResponsiveBreakpoint } from './useResponsiveBreakpoint';

interface ResponsiveState {
  isMobileSm: boolean;
  isMobileMd: boolean;
  isMobile: boolean;
  isTabletSm: boolean;
  isTabletMd: boolean;
  isTablet: boolean;
  isDesktopSm: boolean;
  isDesktopMd: boolean;
  isDesktopLg: boolean;
  isDesktopXl: boolean;
  isDesktop: boolean;
}

type ResponsiveProps = {
  useOnlyAbiTokens?: boolean;
};

export function useResponsive({
  useOnlyAbiTokens,
}: ResponsiveProps): ResponsiveState {
  const currentMediaValue =
    useResponsiveBreakpoint({ useOnlyAbiTokens }) || 'initial';

  const breakpoints = useMemo(
    () => ({
      isMobileSm: currentMediaValue === 'mobileSm',
      isMobileMd: currentMediaValue === 'mobileMd',
      isTabletSm: currentMediaValue === 'tabletSm',
      isTabletMd: currentMediaValue === 'tabletMd',
      isDesktopSm: currentMediaValue === 'desktopSm',
      isDesktopMd: currentMediaValue === 'desktopMd',
      isDesktopLg: currentMediaValue === 'desktopLg',
      isDesktopXl: currentMediaValue === 'desktopXl',
    }),
    [currentMediaValue]
  );

  const isMobile = breakpoints.isMobileSm || breakpoints.isMobileMd;
  const isTablet = breakpoints.isTabletSm || breakpoints.isTabletMd;
  const isDesktop =
    breakpoints.isDesktopSm ||
    breakpoints.isDesktopMd ||
    breakpoints.isDesktopLg ||
    breakpoints.isDesktopXl;

  return {
    ...breakpoints,
    isMobile,
    isTablet,
    isDesktop,
  };
}
